import { formatDateFromTimestamp } from 'apps/journeys/utils/helpers/dates';
import PropTypes from 'prop-types';

const DPSRowDetails = ({ contact = {}, giving }) => {
  const dpsScore = contact?.dps_detail?.dps_score;
  const lastInteractionDate = contact?.dps_detail?.last_interaction_date;
  const lastGiftDate = giving?.last_gift_date;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
      <div>
        <span className="giving-amount">DPS Score: {dpsScore ? dpsScore : 'NA'}</span> | Last Gift:{' '}
        {lastGiftDate ? formatDateFromTimestamp(lastGiftDate) : 'NA'}
      </div>
      <div className="giving-date">
        Last recorded interaction: {lastInteractionDate ? formatDateFromTimestamp(lastInteractionDate) : 'NA'}
      </div>
    </div>
  );
};

DPSRowDetails.propTypes = {
  contact: PropTypes.object,
  giving: PropTypes.object,
};

export default DPSRowDetails;
